import React, { Component, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Breadcrumb, Container, Row, Col, Image } from 'react-bootstrap';
import { storage } from '../../config/fbConfig';
import { ref, getDownloadURL } from 'firebase/storage';
import DOMPurify from 'dompurify';
import BottomSide from '../components/BottomSide';
import NewsImageComponent from './NewsImageComponent';
import ImageGalleryModal from './ImageGalleryModal';
import { Helmet } from 'react-helmet';
import CenteredCircularProgress from '../../components/common/CenteredCircularProgress';

class NewsItemDetailPage extends Component {

    render() {
        const currentUrl = window.location.href;
        const { newsItem } = this.props;

        // Check if news is undefined
        if (!newsItem) {
            return <CenteredCircularProgress />;
        }

        const metaTitle = (newsItem.title ? newsItem.title : "News Detail") + " - Bright Youth Community";
        const plainContent = newsItem.content
            ? DOMPurify.sanitize(newsItem.content, { ALLOWED_TAGS: [] }).replace(/\s+/g, ' ').trim()
            : '';
        const metaDescription = plainContent
            ? plainContent.substring(0, 155)
            : "Find the latest news and updates on our organization's events and projects here. Stay informed about developments and join us.";

        return (

            <div>
                <Helmet>
                    <title>{metaTitle}</title>
                    <meta name="description" content={metaDescription} />
                    <link rel="canonical" href={currentUrl} />

                    <meta property="og:title" content={metaTitle} />
                    <meta property="og:description" content={metaDescription} />
                    <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                    <meta property="og:url" content={currentUrl} />
                    <meta property="og:type" content="website" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={metaTitle} />
                    <meta name="twitter:description" content={metaDescription} />
                    <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                </Helmet>

                <Container className="mt-4">
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/news">News</Breadcrumb.Item>
                        <Breadcrumb.Item active>{newsItem?.title}</Breadcrumb.Item>
                    </Breadcrumb>
                </Container>

                <Container className="mt-4 bg-light" style={{ minHeight: '90px' }}>
                    <Row>
                        <Col xs={12}>
                            <h2>{newsItem?.title}</h2>
                            <small className="text-muted" style={{ textAlign: 'right' }}>{newsItem.created?.toDate?.()?.toLocaleDateString?.() ?? ''}</small>


                            <span> { } </span>
                        </Col>
                    </Row>

                </Container>

                <NewsItemFeaturedImage newsItem={newsItem} />

                <div>
                    <BottomSide />
                </div>



            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { slug } = ownProps.match.params;

    return {
        newsItem: state.firestore.ordered.news && state.firestore.ordered.news.find(news => news.slug === slug)
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        //createQuestions: (questions, courseId, testId) => dispatch()
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect(props => {
        return [
            { collection: 'news', where: [['slug', '==', props.match.params.slug]] },
        ]
    })
)(NewsItemDetailPage);


const NewsItemFeaturedImage = ({ newsItem }) => {
    const [featuredImageUrl, setLogoUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [showImageGalleryModal, setShowImageGalleryModal] = useState(false);
    const [currentImageIdx, setCurrentImageIdx] = useState(null)

    const logoPathAndFile = 'news/' + newsItem.featuredImage;
    const cleanHTML = DOMPurify.sanitize(newsItem.content);

    const handleOnSubImageClickCallback = (index) => {
        setCurrentImageIdx(index);
        setShowImageGalleryModal(true);
    }

    const handleCloseImageGalleryModal = () => {
        setShowImageGalleryModal(false);
    }

    useEffect(() => {
        // Function to get download URL from Firebase Storage
        const getDownloadUrl = async () => {
            try {
                const imageRef = ref(storage, logoPathAndFile);
                const url = await getDownloadURL(imageRef);
                setLogoUrl(url);
                setIsLoading(false);
            } catch (error) {
                console.error('Error getting download URL:', error);
                setIsLoading(false);
            }
        };

        // Call the function to get download URL when component mounts
        if (newsItem?.featuredImage)
            getDownloadUrl();


    }, [newsItem.featuredImage]); // Run this effect when logoPath changes
    

    return (
        <Container className="mt-4 mb-5">
            <div>

                <div style={{ position: 'relative', width: '768px', height: '432px' }}>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        {isLoading && (
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        )}
                    </div>
                    <Image src={featuredImageUrl} thumbnail />
                </div>

                <div className='mt-4 mb-4' dangerouslySetInnerHTML={{ __html: cleanHTML }} />

                <div className="d-flex flex-row flex-wrap">
                    {

                        newsItem?.newsImages?.map((newsImage, index) => (
                            <div key={index}>
                                <NewsImageComponent
                                    imageName={newsImage}
                                    index={index}
                                    handleOnClickCallback={handleOnSubImageClickCallback}
                                />
                            </div>
                        ))
                    }
                </div>

            </div>
            <ImageGalleryModal
                show={showImageGalleryModal}
                handleClose={handleCloseImageGalleryModal}
                newsImages={newsItem?.newsImages}
                currentIndex={currentImageIdx}
            />

        </Container>

    );
}